import { render, staticRenderFns } from "./GroupInfoModal.vue?vue&type=template&id=69e54524&"
import script from "./GroupInfoModal.vue?vue&type=script&lang=js&"
export * from "./GroupInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports